export default __webpack_public_path__ + "assets/icons/faqA.335b143c.svg";